import { useQuery } from "@tanstack/react-query";

export function useItemQuery(key, fn, isEnabled, onError) {
  return useQuery({
    queryKey: key,
    // Always execute caller fn without React Query context args.
    queryFn: () => fn(),
    enabled: isEnabled,
    staleTime: 0, // Mark data as stale immediately so refetch shows loading
    gcTime: 1 * 60 * 1000, // 1 minute
    refetchOnWindowFocus: false,
    onError,
  });
}
